import { CfDataGridColumnDefinition, CfDataGridTableViewDefinition } from '../../../CfDataGridProps';
import { StyledGridRow, StyledGridCell, StyledGridCustomRow, StyledGridCustomCell } from './row.styles';

export function CfDataGridSkeletonRow<TItem>(props: {
  tableViewDefinition: CfDataGridTableViewDefinition<TItem>;
  itemIndex: number;
}): JSX.Element {
  const rowFooterLoadingPlaceholder = props.tableViewDefinition.rowFooterLoadingPlaceholder;
  const rowFooterContent =
    typeof rowFooterLoadingPlaceholder === 'function'
      ? rowFooterLoadingPlaceholder(props.itemIndex)
      : rowFooterLoadingPlaceholder;
  return (
    <>
      <StyledGridRow
        {...(typeof props.tableViewDefinition.bodyTableRowProps === 'function'
          ? props.tableViewDefinition.bodyTableRowProps(undefined)
          : props.tableViewDefinition.bodyTableRowProps)}
      >
        {props.tableViewDefinition.columns.map((col: CfDataGridColumnDefinition<TItem>, index: number) => {
          const bodyCellProps =
            typeof col.bodyCellProps === 'function' ? col.bodyCellProps(undefined, props.itemIndex) : col.bodyCellProps;
          return (
            <StyledGridCell
              key={index}
              {...bodyCellProps}
              sx={{ textAlign: col.horizontalAlignment, width: col.width, ...bodyCellProps?.sx }}
            >
              {typeof col.loadingPlaceholder === 'function'
                ? col.loadingPlaceholder(col, props.itemIndex)
                : col.loadingPlaceholder || ''}
            </StyledGridCell>
          );
        })}
      </StyledGridRow>
      {rowFooterContent && (
        <StyledGridCustomRow>
          <StyledGridCustomCell>{rowFooterContent}</StyledGridCustomCell>
        </StyledGridCustomRow>
      )}
    </>
  );
}
